module.exports = __webpack_public_path__ + "img/public/siteImages/veriff.png?4fb023b1";